module.exports = __webpack_public_path__ + "img/logo.26b325fe.png";